export default __webpack_public_path__ + "static/media/discordCompany.31050b4e.svg";